import produce from 'immer';

const INITIAL_STATE = {
  profile: null,
  language: null,
  modules: [],
  configs: {},
};

export default function user(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@auth/SIGN_IN_SUCCESS': {
        draft.profile = action.payload.user;
        draft.modules = action.payload.modules;
        draft.configs = action.payload.configs;
        draft.language = action.payload.lang;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.profile = null;
        draft.language = null;
        draft.modules = [];
        draft.configs = {};
        break;
      }
      default:
    }
  });
}
